export enum ProductContext {
  DoorContext = "doorContext",
  StandardProductContext = "standardProductContext",
}
